import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getAppUrl } from "../../functions/getEnv";

const LeloResponse = () => {
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const [templateMessage, setTemplateMessage] = useState(null);
  const location = useLocation();
  const {
    firstName,
    lastName,
    session,
    _uuid,
    permalink,
    charter_id,
    charter,
    selectedLearningCenter,
    selectedCourseAgreements,
    courses,
    name,
    LeloRegistrationProfile,
    siteId,
  } = location.state || {};

  const formatTimestamp = () => {
    const date = new Date();
    const year = String(date.getFullYear()).slice(-2);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}${month}${day}_${hours}${minutes}`;
  };

  const sanitize = (str) => str.replace(/[^a-zA-Z0-9]/g, "");

  // Support Template Placeholders
  const replacePlaceholders = (template, variables) => {
    for (const key in variables) {
      template = template.replace(new RegExp(`{{${key}}}`, "g"), variables[key]);
    }
    return template;
  };

  const generateCoursesHTML = (courses) => {
    const tdStyles = `
    color: #000000;
    padding: 5px;
    text-align: center;
  `;

    return courses.map(course => `<tr><td style="${tdStyles}">${course.course_name.join(', ')}</td></tr>`).join('');
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const fetchTemplate = async () => {
     // Prevent API call if values are missing
  
      try {
        let response;
  
        if (!_uuid) {
          response = await axios.get(
            `${appUrl}/api/lelotemplate/${charter_id}/${LeloRegistrationProfile}/${siteId}`
          );
        } else {
          response = await axios.get(
            `${appUrl}/api/lelotemplate/${charter_id}/${LeloRegistrationProfile}/${siteId}`
          );
        }
  
        // Process placeholder data
        if (response.data) {
          const variables = {
            firstName,
            lastName,
            _uuid: _uuid
              ? _uuid
              : `${sanitize(session)}_${sanitize(lastName)}/${sanitize(
                  firstName
                )}_${formatTimestamp()}`,
          };
          const processedTemplate = replacePlaceholders(
            response.data.templateMessage,
            variables
          );
          setTemplateMessage(processedTemplate);
        }
      } catch (error) {
        //console.error("Error fetching template:", error);
      }
    };
  
    fetchTemplate();
    
  }, [charter_id, permalink, name, _uuid, selectedLearningCenter]); 

  return (
    <div className="lelo-response-container">
      <FaIcons.FaClipboardCheck className="lelo-response-icon" />
      <p className="lelo-response-text">
        Thank you for submitting your registration for{" "}
        <strong>
          {firstName} {lastName}
        </strong>
        .
        <div className="registration-table">
        Your registration ID: 
        <strong>
          {_uuid
            ? ' ' + _uuid
            : `${sanitize(session)}_${sanitize(lastName)}_${sanitize(
                firstName
              )}_${formatTimestamp()}`}
        </strong>
        </div>
        <div className="registrationtable registration-table" role="region" tabIndex="0">
        <table>
          <caption>Registration Details</caption>
          <tbody>
            <tr>
              <td>{charter}</td>
              <td>{selectedLearningCenter}</td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <td className="header" fontWeight>Courses</td>
            </tr>
          </thead>
          <tbody dangerouslySetInnerHTML={{ __html: generateCoursesHTML(courses) }}>
          </tbody>
        </table>
        <hr></hr>
      </div>
      <br />
        {templateMessage !== null ? (
          <div dangerouslySetInnerHTML={{ __html: templateMessage }} />
        ) : (
          <>
              <p>You are considered registered and there is nothing more you need to do unless you are contacted by the school for additional information.</p>
              <p>One of our staff members will contact you with instructions and information on how to start your course. They will also be able to answer any questions you may have.</p>
              <p>We look forward to working with you!</p>
            </>
          )}
      </p>
    </div>
  );
};

export default LeloResponse;